(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anzu-aplus-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__anzuAplusCardsInteractive) return;
    window.__anzuAplusCardsInteractive = true;

    function setActive(section, activeTrigger) {
      section.querySelectorAll('[data-aplus-card-trigger]').forEach(function (trigger) {
        var active = trigger === activeTrigger;
        trigger.classList.toggle('is-active', active);
        trigger.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function initInteractiveCards(root) {
      var scope = root || document;
      scope.querySelectorAll('.aplus-cards--interactive').forEach(function (section) {
        if (section.dataset.aplusCardsReady === 'true') return;
        section.dataset.aplusCardsReady = 'true';

        var hero = section.querySelector('[data-aplus-cards-hero]');
        var heroImage = hero && hero.querySelector('img');
        var triggers = section.querySelectorAll('[data-aplus-card-trigger]');
        if (!hero || !heroImage || !triggers.length) return;

        triggers.forEach(function (trigger) {
          trigger.addEventListener('click', function () {
            var nextSrc = trigger.getAttribute('data-hero-src');
            if (!nextSrc) return;

            if (heroImage.getAttribute('src') === nextSrc) {
              setActive(section, trigger);
              return;
            }

            var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            var minDelayDone = reduceMotion;
            var imageReady = false;
            var committed = false;
            var preloader = new Image();

            function commitSwap() {
              if (committed || !minDelayDone || !imageReady) return;
              committed = true;
              heroImage.removeAttribute('srcset');
              heroImage.removeAttribute('sizes');
              hero.style.setProperty('--aplus-hero-aspect', trigger.getAttribute('data-hero-aspect') || '1.777778');
              heroImage.src = nextSrc;
              heroImage.alt = trigger.getAttribute('data-hero-alt') || '';
              setActive(section, trigger);
              window.requestAnimationFrame(function () {
                hero.classList.remove('is-swapping');
              });
            }

            hero.classList.add('is-swapping');
            preloader.onload = function () {
              imageReady = true;
              commitSwap();
            };
            preloader.onerror = function () {
              imageReady = true;
              commitSwap();
            };
            preloader.src = nextSrc;

            window.setTimeout(function () {
              minDelayDone = true;
              commitSwap();
            }, reduceMotion ? 0 : 160);

            window.setTimeout(function () {
              imageReady = true;
              minDelayDone = true;
              commitSwap();
            }, 900);
          });
        });
      });
    }

    if (document.readyState !== 'loading') initInteractiveCards(document);
    else document.addEventListener('DOMContentLoaded', function () { initInteractiveCards(document); });
    document.addEventListener('shopify:section:load', function (event) { initInteractiveCards(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
